import {isUndefined as _isUndefined} from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
/* eslint import/no-unresolved: 0 */
import {withRouter} from 'react-router';
import {compose} from 'redux';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {Button, Header} from 'semantic-ui-react';

import {graphql, gql} from 'react-apollo';
import Authorization from '@appComponents/Authorization';
import {ButtonCancel} from '@appComponents/ButtonCollection';
import {FormWrapper} from '@appComponents/HOCFormWrapper';
import Form from '@appComponents/ReduxFormControls';
import MessageBox from '@appComponents/MessageBox';
import {refetchQueryByName} from '@utils/apollo';
import {filterDisabledEncodingJobProfiles} from '@utils/helpers';
import {showPopupMessage} from '@utils/popupMessage/PopupMessageService';
import * as RESOURCES from '@constants/resources';
import * as CONST from '@constants/variables';
import {
    DELETED,
    DELETE_CONFIRMATION,
    DELETE_HEADER,
    DELETING,
    NOT_DELETED,
    NOT_SAVED,
    SAVED,
} from '@constants/messages';
import * as thirdPartyGraphQl from '@graphql/clients/thirdPartyPullOrigin';
import {GetThirdPartyPullOriginDropdowDataForForm} from '@graphql/thirdPartyClientPullOrigin/query';

import validate from './validatorThirdPartyPullOrigins';

export class ThirdPartyPullOriginsForm extends React.Component {
    static propTypes = {
        clientProductThirdPartyId: PropTypes.number.isRequired,
        CreateThirdPartyPullOrigin: PropTypes.func,
        dataForForm: PropTypes.object,
        dataMap: PropTypes.object,
        DataThirdPartyPullOriginsDropdowns: PropTypes.object,
        DeleteThirdPartyPullOrigin: PropTypes.func,
        formData: PropTypes.object.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        MessageBox: PropTypes.object,
        Modal: PropTypes.object,
        resetIndexUrl: PropTypes.func.isRequired,
        submitting: PropTypes.bool,
        UpdateThirdPartyPullOrigin: PropTypes.func,
    };

    constructor() {
        super();

        this.state = {
            encodingDatacenters: [],
            encodingJobProfiles: [],
        };
    }

    componentDidUpdate(prevProps) {
        const {
            DataThirdPartyPullOriginsDropdowns: {encodingDatacenters, encodingJobProfiles},
        } = this.props;

        if (prevProps.DataThirdPartyPullOriginsDropdowns !== this.props.DataThirdPartyPullOriginsDropdowns) {
            let nextState = {};

            if (encodingDatacenters) {
                nextState.encodingDatacenters = encodingDatacenters;
            }

            if (encodingJobProfiles) {
                nextState.encodingJobProfiles = encodingJobProfiles;
            }

            this.setState(() => (nextState));

            if (false === this.props.DataThirdPartyPullOriginsDropdowns.loading) {
                this.props.Modal.setModal({
                    loading: false,
                });
            }
        }
    }

    formSubmit = (data) => {
        let dataSaved;

        const dataToSave = {
            ...this.props.dataMap.thirdPartyPullOrigin,
            ...data,
            client_product_third_party: this.props.clientProductThirdPartyId,
            encoding_datacenter: data.encoding_datacenter,
            encoding_job_profile: data.encoding_job_profile,
        };

        if (0 === dataToSave.id.length) {
            dataSaved = this.props.CreateThirdPartyPullOrigin({
                variables: {...dataToSave},
            }).then(() => {
                showPopupMessage(SAVED(`pull origin "${data.name}"`), 'success');
                refetchQueryByName('GetThirdPartyClientPullOrigins');
                this.props.Modal.setModal({isVisible: false});
                this.props.resetIndexUrl();
            }).catch((error) => {
                showPopupMessage(
                    NOT_SAVED(`pull origin "${data.name}"`),
                    'error',
                    true,
                    `${error}`
                );
            });
        } else {
            dataSaved = this.props.UpdateThirdPartyPullOrigin({
                variables: {...dataToSave},
            }).then(() => {
                showPopupMessage(SAVED(`pull origin "${data.name}"`), 'success');
                refetchQueryByName('GetThirdPartyClientPullOrigins');
                this.props.Modal.setModal({isVisible: false});
                this.props.resetIndexUrl();
            }).catch((error) => {
                showPopupMessage(
                    NOT_SAVED(`pull origin "${data.name}"`),
                    'error',
                    true,
                    `${error}`
                );
            });
        }

        return dataSaved.then();
    };

    deleteThirdPartyPullOrigin = (id) => {
        this.props.Modal.setModalConfirmation({
            text: DELETING(`pull origin "${this.props.dataForForm.thirdPartyPullOrigin.name}"`),
        });

        return this.props.DeleteThirdPartyPullOrigin({
            variables: {
                id: id,
            },
        }).then(() => {
            showPopupMessage(
                DELETED(`pull origin "${this.props.dataForForm.thirdPartyPullOrigin.name}"`),
                'success'
            );
            refetchQueryByName('GetThirdPartyClientPullOrigins');
            this.props.Modal.setModal({isVisible: false});
            this.props.resetIndexUrl();
        }).catch((error) => {
            this.props.Modal.setModal({isVisible: false});
            showPopupMessage(
                NOT_DELETED(`pull origin "${this.props.dataForForm.thirdPartyPullOrigin.name}"`),
                'error',
                true,
                `${error}`
            );
        });
    };

    handleApplicationDelete = () => {
        const data = this.props.dataForForm.thirdPartyPullOrigin;

        this.props.Modal.setModalConfirmation({
            header: <Header icon='trash' content={DELETE_HEADER('pull origin')}/>,
            onYes: () => (this.deleteThirdPartyPullOrigin(parseInt(data.id, 10))),
            text: DELETE_CONFIRMATION(`pull origin "${this.props.dataForForm.thirdPartyPullOrigin.name}"`),
        });
    };

    renderDeleteButton = () => {
        let deleteButton = null;

        if (!_isUndefined(this.props.dataForForm.thirdPartyPullOrigin.id) &&
            ('' !== this.props.dataForForm.thirdPartyPullOrigin.id)
        ) {
            deleteButton =
                <Button
                    onClick={this.handleApplicationDelete}
                    color='red'
                    content='Delete'
                    disabled={this.props.submitting}
                    icon='trash'
                />;
        }

        return deleteButton;
    };

    closeModal = (e) => {
        e.preventDefault();

        this.props.Modal.setModal({
            content: null,
            isVisible : false,
        });
        this.props.resetIndexUrl();
    };

    render() {
        return (
            <div>
                <Header as='h3' dividing>
                    {(this.props.dataForForm.thirdPartyPullOrigin.id)
                        ? `Pull origin "${this.props.dataForForm.thirdPartyPullOrigin.name}" `
                        : 'Add new pull origin'
                    }
                </Header>
                <MessageBox name='clientProductPullOriginMessage'/>
                <Form.Create
                    loading={this.props.formData.loading}
                    onSubmit={this.props.handleSubmit(this.formSubmit)}
                >
                    <Form.IdField
                        defaultValue={this.props.dataForForm.thirdPartyPullOrigin.id}
                    />
                    <Form.FormRow
                        component={Form.SemanticInput}
                        defaultValue={this.props.dataForForm.thirdPartyPullOrigin.name}
                        label='Name'
                        name='name'
                        required
                        autoFocus
                    />
                    <Form.FormRow
                        component={Form.SemanticSelect}
                        defaultValue={this.props.dataForForm.thirdPartyPullOrigin.encoding_datacenter.id}
                        options={this.state.encodingDatacenters}
                        loading={this.props.DataThirdPartyPullOriginsDropdowns.loading}
                        disabled={this.props.DataThirdPartyPullOriginsDropdowns.loading}
                        label='Encoding datacenter'
                        name='encoding_datacenter'
                        required
                    />
                    <Form.FormRow
                        component={Form.SemanticSelect}
                        defaultValue={this.props.dataForForm.thirdPartyPullOrigin.encoding_job_profile.id}
                        options={filterDisabledEncodingJobProfiles(
                            this.state.encodingJobProfiles,
                            this.props.dataForForm.thirdPartyPullOrigin.encoding_job_profile.id
                        )}
                        loading={this.props.DataThirdPartyPullOriginsDropdowns.loading}
                        disabled={this.props.DataThirdPartyPullOriginsDropdowns.loading}
                        label='Encoding job profile'
                        name='encoding_job_profile'
                        required
                    />
                    <Form.FormRowChangelog
                        resources={RESOURCES.THIRD_PARTY_CLIENT_PULL_ORIGIN}
                        data={this.props.formData?.thirdPartyPullOrigin || {}}
                    />
                    <div className='formRow form__footer'>
                        <label/>
                        <Button
                            color='blue'
                            content={this.props?.formData?.thirdPartyPullOrigin?.id ? 'Save' : 'Create'}
                            disabled={ this.props.submitting }
                            icon='save'
                            loading={ this.props.submitting }
                            type='submit'
                        />
                        <Authorization
                            privileges={CONST.SECURITY_PRIVILEGES_DELETE}
                            resources={RESOURCES.THIRD_PARTY_CLIENT_PULL_ORIGIN}
                        >
                            {this.renderDeleteButton()}
                        </Authorization>
                        <ButtonCancel
                            disabled={this.props.submitting}
                            onClick={ this.closeModal }
                        >
                            Cancel
                        </ButtonCancel>
                    </div>
                </Form.Create>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        initialValues: {
            encoding_job_profile: ownProps.dataForForm.thirdPartyPullOrigin.encoding_job_profile.id,
            encoding_datacenter: ownProps.dataForForm.thirdPartyPullOrigin.encoding_datacenter.id,
        },
    };
};

const ThirdPartyPullOriginsFormRedux = reduxForm({
    form: 'ThirdPartyPullOrigin',
    validate,
})(withRouter(ThirdPartyPullOriginsForm));

export default compose(
    graphql(gql(thirdPartyGraphQl.createThirdPartyPullOrigin), {name: 'CreateThirdPartyPullOrigin'}),
    graphql(gql(thirdPartyGraphQl.deleteThirdPartyPullOrigin), {name: 'DeleteThirdPartyPullOrigin'}),
    graphql(gql(thirdPartyGraphQl.updateThirdPartyPullOrigin), {name: 'UpdateThirdPartyPullOrigin'}),
    graphql(GetThirdPartyPullOriginDropdowDataForForm, {
        options: () => {
            return {
                fetchPolicy: 'cache-and-network',
                notifyOnNetworkStatusChange: true,
                variables: {
                    products: [CONST.PRODUCT_THIRD_PARTY],
                },
            };
        },
        name: 'DataThirdPartyPullOriginsDropdowns',
    })
)(FormWrapper({
    thirdPartyPullOrigin: {
        encoding_datacenter: {id: ''},
        encoding_job_profile: {id: ''},
        id: '',
        name: '',
    },
}, (connect(mapStateToProps)(ThirdPartyPullOriginsFormRedux))));
